import React from 'react';
import { Stack, TextField, Typography } from '@mui/material';
import { CptFormErrors } from '../hooks';

interface RateWeightFieldsProps {
    baseRate: number;
    relativeWeight: number | null;
    errors: CptFormErrors;
    onBaseRateChange: (value: number) => void;
    onRelativeWeightChange: (value: number | null) => void;
}

export const RateWeightFields: React.FC<RateWeightFieldsProps> = ({
    baseRate,
    relativeWeight,
    errors,
    onBaseRateChange,
    onRelativeWeightChange
}) => {
    return (
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField
                label="Base Rate"
                type="number"
                value={baseRate}
                onChange={(e) => onBaseRateChange(parseFloat(e.target.value) || 0)}
                error={!!errors.baseRate}
                helperText={errors.baseRate}
                size="small"
                sx={{ flex: 1 }}
                inputProps={{ min: 0, step: 0.01 }}
                InputProps={{
                    startAdornment: <Typography sx={{ mr: 1, color: 'text.secondary' }}>$</Typography>
                }}
            />
            <TextField
                label="Relative Weight"
                type="number"
                value={relativeWeight || ''}
                onChange={(e) => {
                    const value = e.target.value;
                    onRelativeWeightChange(value ? parseFloat(value) : null);
                }}
                error={!!errors.relativeWeight}
                helperText={errors.relativeWeight || 'Optional - leave empty if not applicable'}
                size="small"
                sx={{ flex: 1 }}
                inputProps={{ min: 0, step: 0.0001 }}
                placeholder="Optional"
            />
        </Stack>
    );
};
